import { defineMessages } from '@/i18n';

export const listingsMessages = defineMessages({
  title: 'storefront.app.artworks.title',
  priceOnRequest: 'storefront.app.artworks.detail.priceOnRequest',
  artistBioLabel: 'storefront.app.artworks.detail.artistBioLabel',
  otherListingsLabel: 'storefront.app.artworks.detail.otherListingsLabel',
  notFound: 'storefront.app.notFoundContent.title',
  showMoreLabel: 'storefront.app.artworks.list.showMoreLabel',
  endOfResults: 'storefront.app.artworks.list.endOfResults',
  resultCountLabel: 'storefront.app.artworks.list.resultCountLabel',

  // Digital Dossier
  coaTitleShort: 'storefront.app.artworks.digitalDossier.certificateOfAuthenticity.titleShort',
  resaleTermsTitle: 'storefront.app.artworks.digitalDossier.resaleTerms.title',
  digitalPortfolio: 'storefront.app.artworks.digitalDossier.title',
  supportingDocumentsTitle: 'storefront.app.artworks.digitalDossier.supportingDocuments.title',
});
